import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import CardDesignerCardElementColorControl from '../CardDesignerCardElementControls/components/CardDesignerCardElementColorControl';

const propTypes = {
  element: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
  }).isRequired,
  onElementConfigurationChange: PropTypes.func.isRequired,
};

const CardDesignerCardElementRectangleControls = ({
  element,
  onElementConfigurationChange,
}) => {
  const { cardElementConfiguration = {} } = element;

  return (
    <Fragment>
      <CardDesignerCardElementColorControl
        onChange={hex => {
          onElementConfigurationChange({
            element,
            elementConfig: {
              color: hex,
            },
          });
        }}
        defaultColor={cardElementConfiguration.color ?? undefined}
      />
    </Fragment>
  );
};

CardDesignerCardElementRectangleControls.propTypes = propTypes;

export default CardDesignerCardElementRectangleControls;
